import { IStore } from "services/indexdb/interface/istore";

export const DashboardSettingsStore: IStore = {
    Name: 'DashboardSettings',
    PrimaryField: 'id',
    minimumVersion: 2
}